import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from '@mui/material';
import CustomTable from './Table';

const DietPlanResults = ({
  dietPlans = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={dietPlans}
        dataKeysSequence={[

          'name',
          'diet',
          'actions'
        ]}
        headers={[ 'Name', 'diet','Actions']}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

DietPlanResults.propTypes = {
  dietPlans: PropTypes.array.isRequired
};

export default DietPlanResults;
